import React, { useState, useContext, useEffect } from 'react'
import fetchHook from '../../hooks/fetchMSSQL-hook'
import { NavigationContext } from '../../context/navigation-context'
import formHook from '../../hooks/form-hook'
import NoResults from '../../components/NoResults/NoResults'
import FormSkel from '../../components/Modals/FormSkel'
import OnceSelector from '../../components/OptionSelector/OnceSelector'
import { NotificationManager } from 'react-notifications'


const automatTypes = [
    {name: "Snack", value: false },
    {name: "Kawowy", value: true },
]
const actionType = [
    {name: "Brak"             , value: null , colour: "secondary" },
    {name: "Rozładowanie (RO)", value: false, colour: "danger"    },
    {name: "Doładowanie (DO)" , value: true , colour: "primary"   },
]



export default function CorrectionReason() {
    const { form, openForm, closeForm } = formHook()
    const { fetchMssqlApi } = fetchHook()
    const { setHeaderData } = useContext(NavigationContext)
    const [correctionReasons, setCorrectionReasons] = useState(null)
    const defaultFilter = {
        sortBy: "none"
    }
    const [filter, setFilter] = useState(defaultFilter)
    const [sortFieldDisplay, setSortFieldDisplay] = useState(null)
    const defaultFormState = {
        IsLoad: null,
        IsCoffee: false,
        Name: "",
        IsActive: true
    }
    const [formState, setFormState] = useState()

    const sortDefaults = {
        Name: "ASC",
        IsActive: "DESC",
        IsLoad: "ASC",
        IsCoffee: "DESC"
    }

    const getSortState = () => {
        const [field, dir] = String(filter.sortBy || "").split("|")
        return {
            field,
            dir: (dir || "").toUpperCase(),
            displayField: sortFieldDisplay || field
        }
    }

    const sortState = getSortState()

    const arrow = (field) => {
        if (sortState.displayField !== field) return ""
        return sortState.dir === "ASC" ? " ▲" : " ▼"
    }

    const normalizeIsLoad = (value) => {
        if (value === null || value === undefined || value === "") return null
        if (value === true || value === 1 || value === "1") return true
        if (value === false || value === 0 || value === "0") return false
        return null
    }

    const getCorrectionReasons = (f = filter) => {
        fetchMssqlApi('/correction-reasons', {
            params: {
                sortBy: f?.sortBy
            }
        }, res => {
            setCorrectionReasons(res)
        })
    }

    const handleHeaderSort = (field, displayField = field, startDir = null) => {
        const [curField, curDirRaw] = String(filter.sortBy || "").split("|")
        const curDir = (curDirRaw || "").toUpperCase()

        let nextDir
        if (curField === field && sortFieldDisplay === displayField) {
            nextDir = curDir === "ASC" ? "DESC" : "ASC"
        } else {
            nextDir = startDir || sortDefaults[field] || "ASC"
        }

        const next = {
            ...filter,
            sortBy: `${field}|${nextDir}`
        }

        setSortFieldDisplay(displayField)
        setFilter(next)
        getCorrectionReasons(next)
    }

    const handleChangeAutomatType = () => setFormState(prev => ({...prev, IsCoffee: !prev.IsCoffee}))
    const handleChangeActionType = (value) => setFormState(prev => ({...prev, IsLoad: value})) 
    const handleFocusInput = () =>  setFormState(prev => ({...prev, Name: ""}))
    const handleChangeName = (evt) => {
        const value = evt.target.value
        setFormState(prev => ({...prev, Name: value}))
    } 
    const returnCheckbox = (value) => (
        <div className='h-100 w-100 justify-content-center align-items-center'>
            <input
                type='checkbox'
                onChange={() => {}}
                checked={value}
            />
        </div>
    )

const checkDeactivateButtonAndReturnData = (evt) => {
    const submitter = evt.nativeEvent?.submitter;
    const fromIsActiveToggle = submitter?.id === 'isActive';

    const prevCr = correctionReasons?.find(
        i => i.CorrectionReasonId === formState?.CorrectionReasonId
    );

    const payload = {
        CorrectionReasonId: formState?.CorrectionReasonId ?? null,
        Name: formState?.Name ?? prevCr?.Name ?? "",
        IsLoad: formState?.IsLoad ?? prevCr?.IsLoad ?? null,
        IsCoffee: formState?.IsCoffee ?? prevCr?.IsCoffee ?? false,
        IsActive: formState?.IsActive ?? prevCr?.IsActive ?? true
    };

    if (!fromIsActiveToggle) return payload;

    return {
        ...payload,
        IsActive: !Boolean(prevCr?.IsActive ?? formState?.IsActive)
    };
};

    const handleSubmit = (evt) => {
        evt.preventDefault()
        if (
            correctionReasons
            .filter(i => i.CorrectionReasonId !== formState.CorrectionReasonId)
            .filter(i => String(i.Name).trim() === String(formState.Name).trim())
            .length
        ) {
            NotificationManager.error("Nazwa musi być unikalna")
            setFormState(prev => ({...prev, Name: ""}))
            return
        }
        fetchMssqlApi(`correction-reason${formState.CorrectionReasonId ? "/" + formState.CorrectionReasonId : ''}`, {
            method: formState.CorrectionReasonId ? "PUT": "POST",
            data: checkDeactivateButtonAndReturnData(evt),
        }, () => {
            setFormState(defaultFormState)
            getCorrectionReasons()
            closeForm()
        })
    }

    useEffect(() => {
        !form && setFormState(defaultFormState) 
    }, [form])

    useEffect(() => {
        formState?.CorrectionReasonId && openForm()(formState.CorrectionReasonId)
    }, [formState])

    useEffect(() => {
        setHeaderData({text: "Powody korekt"})
        getCorrectionReasons()
    }, [])

    return (
        <div>
            <div className='card mt-4'>
                <div className='card-header'>
                    <div className='d-flex justify-content-between align-items-center'>
                        <div></div>
                        <button onClick={openForm(null)} className="btn text-nowrap btn-outline-secondary">
                            <i className="fas fa-plus" />
                        </button>
                    </div>
                </div>
                <div>
                    {correctionReasons ?
                        (<table className="table table-striped">
                            <thead>
                                <tr className="text-center headers-color">
                                    <th
                                        style={{ cursor: "pointer", userSelect: "none" }}
                                        onClick={() => handleHeaderSort("Name")}
                                    >
                                        Nazwa{arrow("Name")}
                                    </th>
                                    <th
                                        style={{ cursor: "pointer", userSelect: "none" }}
                                        onClick={() => handleHeaderSort("IsActive")}
                                    >
                                        Aktywna{arrow("IsActive")}
                                    </th>
                                    <th
                                        style={{ cursor: "pointer", userSelect: "none" }}
                                        onClick={() => handleHeaderSort("IsLoad", "RO", "ASC")}
                                    >
                                        RO{arrow("RO")}
                                    </th>
                                    <th
                                        style={{ cursor: "pointer", userSelect: "none" }}
                                        onClick={() => handleHeaderSort("IsLoad", "DO", "DESC")}
                                    >
                                        DO{arrow("DO")}
                                    </th>
                                    <th
                                        style={{ cursor: "pointer", userSelect: "none" }}
                                        onClick={() => handleHeaderSort("IsCoffee")}
                                    >
                                        Automat kawowy{arrow("IsCoffee")}
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {correctionReasons.map((cr, idx) => (
                                    <tr key={idx} className='text-center'>
                                        <td>{cr.Name}</td>
                                        <td className='text-center'>
                                            {returnCheckbox(cr.IsActive)}
                                        </td>
                                        <td className='text-center'>
                                            {returnCheckbox(cr.IsLoad === 0 || cr.IsLoad === false)}
                                        </td>
                                        <td className='text-center'>
                                            {returnCheckbox(cr.IsLoad === 1 || cr.IsLoad === true)}
                                        </td>
                                        <td className='text-center'>
                                            {returnCheckbox(cr.IsCoffee)}
                                        </td>
                                        <td className='d-flex justify-content-end border-0'>
                                            <button className="btn btn-outline-primary btn-sm pb-1"
                                                onClick={() => {
                                                    let f = correctionReasons && correctionReasons.find(i => i.CorrectionReasonId === cr.CorrectionReasonId) || defaultFormState;
                                                    setFormState(f)
                                                }}
                                            >
                                                Edytuj
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>)
                    : (<NoResults/>)}
                </div>
            </div>
            {
                form && (
                    <FormSkel
                        headerText={!formState.CorrectionReasonId ? "Nowy powód korekty" : "Powód korekry" }
                        handleClose={closeForm} 
                        deleteDisable={!formState.CorrectionReasonId}
                        disableSubmit={!formState.Name}
                        data={formState}
                        acceptForm={false}
                        handleSubmit={handleSubmit}
                    >
                        <form onSubmit={handleSubmit} id="modal-form" autoComplete="off">
                            <div className="form-group"> 
                                <label className="h6">Nazwa</label>
                                <input
                                    onFocus={handleFocusInput}
                                    name="name"
                                    onKeyDown={evt => {
                                        if(evt.key === "Enter") evt.preventDefault()
                                    }}
                                    onChange={handleChangeName}
                                    minLength={1}
                                    required={true}
                                    value={formState.Name}
                                    className={`form-control ${!formState?.Name && `invalid-input`}`}
                                    placeholder='Wpisz nazwę...'
                                />
                            </div>
                            <div className="form-group"> 
                                <label className="h6">Dokument przesunięcia towaru</label>
                                <OnceSelector
                                    options={actionType}
                                    setState={handleChangeActionType}
                                    defaultValue={normalizeIsLoad(formState.IsLoad)}
                                />
                            </div>
                            <div className="form-group"> 
                                <div className='d-flex'>
                                    <h6 className='mb-0'>Automat kawowy</h6>
                                    <input
                                        checked={formState.IsCoffee}
                                        onChange={handleChangeAutomatType}
                                        className='mr-3 ml-3'
                                        type='checkbox'
                                        name='isCoffee'
                                    />
                                </div>
                            </div>
                        </form>
                    </FormSkel>
                )
            }
        </div>
    )
}